import React from 'react';
import { Select } from '~/common/components/Select';
import { Field } from 'formik';
import { orderedStateList } from '~/common/util/states';
import { ConditionalStateSelectProps } from '~/common/types';
import { validateSelect } from '~/common/util/customValidation';

export const ConditionalStateSelect = (props: ConditionalStateSelectProps) => {
  const { formikTouched, formikErrors, formikValues, trackBlur, trackErrorBlur } = props;
  const selectedCountry = formikValues['country'];
  const id = 'state';
  const stateList = orderedStateList(selectedCountry);
  const customStateLabel = (() => {
    switch (selectedCountry) {
      case 'US':
        return 'State';
      case 'CA':
      case 'AU':
        return 'Province';
      case 'NZ':
        return 'Region';
      default:
        return 'State';
    }
  })();
  return (
    <Field
      name={id}
      as={Select}
      disabled={false}
      error={formikErrors[id] && formikTouched[id]}
      valid={formikValues[id] !== ''}
      errormessage={'Field is required'}
      validate={validateSelect}
      required
      label={customStateLabel}
      defaultValue={formikValues[id]}
      onBlur={(event: React.FocusEvent<HTMLSelectElement>) => {
        trackBlur(id);
        trackErrorBlur(id, validateSelect, event.target.value);
      }}
    >
      {stateList.map((stateName: any, optionindex: number) => {
        return (
          <option key={optionindex.toString()} value={stateName}>
            {stateName}
          </option>
        );
      })}
    </Field>
  );
};
